// extracted by mini-css-extract-plugin
export default {"main":"ModalContactoPrueba_main__aVvXJ","intro":"ModalContactoPrueba_intro__aJOQ9","input":"ModalContactoPrueba_input__PB19S"};